import * as React from 'react';
import { observer } from 'mobx-react';
import { HomeLocationPopUp } from '../../components/organisms/home_locations/HomeLocationPopUp';
import { HomeLocationIntroductionPageState } from './states/HomeLocationIntroductionPageState';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';

@observer
export class HomeLocationIntroductionPage extends React.Component {
    pageState = new HomeLocationIntroductionPageState();

    componentDidMount(): void {
        this.pageState.init();
    }

    render() {
        if (this.pageState.loading) {
            return <LoaderRow />;
        }
        const { baseList, selectedLocationId, selectLocation, abort, submit, submitting } = this.pageState;
        return (
            <HomeLocationPopUp
                locations={baseList}
                selectedLocationId={selectedLocationId}
                loading={submitting}
                onSelect={selectLocation}
                onRequestClose={abort}
                onSubmit={submit}
            />
        );
    }
}
